export default {
  brand: {
    company: 'SytoonTech',
    companyTagline: 'Utility Software Engineering',
    platform: 'Power Tech Knowledge Platform',
    platformShort: 'Knowledge Platform'
  },
  nav: {
    home: 'Home',
    products: 'Products',
    solutions: 'Solutions',
    about: 'About',
    contact: 'Contact',
    platform: 'Knowledge Platform',
    articles: 'Docs',
    topics: 'Topics',
    software: 'Software',
    projects: 'Projects',
    free: 'Free',
    paid: 'Points',
    login: 'Login',
    register: 'Sign up',
    logout: 'Logout',
    center: 'Account',
    upload: 'Upload',
    buyPoints: 'Points',
    langEn: 'EN',
    langZh: '中文'
  },
  common: {
    learnMore: 'Learn more',
    contactUs: 'Contact us',
    viewAll: 'View all',
    search: 'Search',
    submit: 'Submit',
    back: 'Back',
    loading: 'Loading…',
    empty: 'No data yet',
    cancel: 'Cancel',
    confirm: 'Confirm',
    download: 'Download',
    preview: 'Preview',
    remove: 'Remove',
    all: 'All',
    free: 'Free',
    points: 'Points',
    pointsN: '{n} points',
    email: 'Email',
    category: 'Category',
    type: 'Type',
    sort: 'Sort',
    loadFailed: 'Failed to load',
    operationFailed: 'Operation failed',
    downloadFailed: 'Download failed',
    downloadStarted: 'Download started',
    copyFailed: 'Copy failed',
    alreadyRedeemed: 'Already redeemed',
    redeemSuccess: 'Redeemed successfully',
    pointsShort: '{n} pts',
    userFallback: 'User'
  },
  corporate: {
    home: {
      title: 'SytoonTech — STS Prepaid, AMI & Utility Metering Software',
      description: 'SytoonTech builds STS prepaid metering, AMI collection, MDM, FDM, meter management and utility operations software for power utilities worldwide.',
      keywords: 'SytoonTech,STS prepaid,AMI,MDM,FDM,meter management,utility software,smart metering,energy software',
      heroTitle: 'Intelligent metering software, delivered.',
      heroSub: 'From prepaid STS and AMI collection to meter assets and utility operations — software built for reliable field and back-office delivery.',
      heroSlides: 'Hero background slides',
      heroSlideN: 'Show slide {n}',
      ctaProducts: 'Explore solutions',
      ctaContact: 'Contact us',
      pillarsTitle: 'Our solutions',
      solutionsIntro: 'Purpose-built software for prepaid metering, AMI data, meter lifecycle and day-to-day utility operations.',
      pillar1Title: 'STS Prepaid Metering',
      pillar1Body: 'Vending, token lifecycle and meter-side prepaid control for electricity utilities.',
      pillar2Title: 'AMI & Energy Data',
      pillar2Body: 'Collection, validation and operational visibility across the meter fleet.',
      pillar3Title: 'Meter Management',
      pillar3Body: 'Asset registry, inventory and installation workflows from warehouse to field.',
      featureEyebrow: 'Knowledge platform',
      featureTitle: 'Technical documents for the power industry',
      featureBody: 'Access standards, metering practice notes, software downloads and project requirements on the SytoonTech knowledge platform.',
      missionTitle: 'Engineering trust into every delivery',
      missionBody: 'We partner with utilities and solution providers to deploy production-grade metering and energy software — with clear ownership from core engines to operational consoles.',
      missionCta: 'Learn about SytoonTech'
    },
    products: {
      title: 'Products — STS Prepaid, AMI, MDM, FDM & Meter Software | SytoonTech',
      description: 'Explore SytoonTech products: STS prepaid, AMI collection, MDM, FDM, meter management, meter configuration, utility operations and mobile apps.',
      keywords: 'STS prepaid software,AMI software,MDM,FDM,meter configuration,meter management,utility mobile app,smart metering products',
      heading: 'Product portfolio',
      intro: 'Software for prepaid metering, AMI, meter data, field devices, operations and mobile channels.',
      stsName: 'STS Prepaid Metering Software',
      stsSummary: 'End-to-end STS prepaid vending, token generation and meter integration for electricity utilities.',
      amiName: 'AMI Energy Data Collection',
      amiSummary: 'Scalable AMI head-end and collection software for meter reading, validation and energy analytics.',
      mmsName: 'Meter Management System',
      mmsSummary: 'Centralized meter asset, inventory, installation and lifecycle management.',
      umsName: 'Utility Management Software',
      umsSummary: 'Modular operations software for customer service, field work and utility back-office processes.',
      mdmName: 'MDM Meter Data Management',
      mdmSummary: 'VEE, aggregation and billing-ready meter data services for CIS and analytics.',
      fdmName: 'FDM Field Device Management',
      fdmSummary: 'Firmware, configuration, commissioning and remote control for the meter fleet.',
      appName: 'Utility Mobile Apps',
      appSummary: 'Customer, agent and field apps integrated with prepaid, AMI and meter systems.',
      cfgName: 'Meter Configuration Software',
      cfgSummary: 'Parameter, tariff and STS key setup for lab and field meter commissioning.',
      casesTitle: 'Selected project cases',
      casesIntro: 'Representative overseas deliveries across prepaid, smart electricity operations and AMI collection.',
      caseAfricaRegion: 'Africa',
      caseAfricaTitle: 'National smart prepaid system',
      caseAfricaBody: 'STS prepaid vending, token services and meter integration for a national electricity utility program.',
      caseMeRegion: 'Middle East',
      caseMeTitle: 'Smart electricity management platform',
      caseMeBody: 'Utility operations software covering customer service, field workflows and metering back-office processes.',
      caseThRegion: 'Thailand',
      caseThTitle: 'AMI data collection system',
      caseThBody: 'AMI head-end collection, validation and operational monitoring for a regional smart metering rollout.'
    },
    productDetail: {
      capabilities: 'Key capabilities',
      standards: 'Standards & protocols',
      scenarios: 'Typical scenarios',
      cta: 'Request a consultation'
    },
    about: {
      title: 'About SytoonTech — Power Industry Software & Consulting',
      description: 'About SytoonTech: overseas power consulting, STS/AMI software development, integration and long-term maintenance for utilities worldwide.',
      keywords: 'SytoonTech about,power industry consulting,utility software company,STS AMI development,metering software vendor',
      heading: 'About us',
      body1: 'Software engineering for electricity and utility digital systems — prepaid metering, AMI and meter operations.',
      body2: 'We combine STS/AMI domain knowledge with practical delivery: architecture, software, integration and ongoing support for overseas utility programs.',
      servicesTitle: 'What we do',
      servicesIntro: 'Consulting, software delivery and lifecycle support.',
      s1Title: 'Overseas power consulting',
      s1Body: 'Metering schemes, prepaid/AMI roadmaps, vendor selection and localization for multi-country projects.',
      s2Title: 'Utility software development',
      s2Body: 'STS engines, AMI/MDMS workflows, meter management and operations consoles — reliable and auditable.',
      s3Title: 'Integration & rollout',
      s3Body: 'Connect meters, vending, payments and enterprise systems — from pilot to cut-over.',
      s4Title: 'Maintenance & evolution',
      s4Body: 'Monitoring, patches, upgrades and remote support so systems stay stable after go-live.',
      capabilityTitle: 'Capabilities',
      c1: 'Overseas power and metering project consulting',
      c2: 'STS prepaid / AMI / meter management expertise',
      c3: 'Custom and productized utility software',
      c4: 'Meter, vending and enterprise integration',
      c5: 'Localization and multi-market deployment',
      c6: 'Long-term maintenance and remote support'
    },
    contact: {
      title: 'Contact SytoonTech — Utility Metering Projects',
      description: 'Contact SytoonTech for STS prepaid, AMI, MDM, meter configuration and utility software projects. Email sytoontech@gmail.com.',
      keywords: 'contact SytoonTech,STS prepaid inquiry,AMI project,utility software contact,metering consultation',
      heading: 'Contact',
      intro: 'Tell us about your metering or utility software needs. We typically respond on business days.',
      email: 'Email',
      hours: 'Business hours',
      hoursValue: 'Weekdays 09:00 – 18:00 (GMT+8)',
      note: 'For the community knowledge platform, use the Knowledge Platform entry in the header.',
      guestbookTitle: 'Leave a message',
      guestbookIntro: 'Share your project needs or feedback. We review messages on business days.',
      guestbookName: 'Name',
      guestbookNamePh: 'Your name or company',
      guestbookContact: 'Contact',
      guestbookContactPh: 'Email or phone',
      guestbookContent: 'Message',
      guestbookContentPh: 'How can we help?',
      guestbookRequired: 'Please fill in all fields.',
      guestbookSuccess: 'Thanks — your message has been sent.',
      guestbookFail: 'Could not send. Please try again later.'
    },
    footer: {
      rights: 'All rights reserved.',
      platformHint: 'Looking for technical documents and community downloads?',
      mission: 'Utility metering and energy software for prepaid, AMI and operations.',
      allProducts: 'All products',
      company: 'Company',
      connect: 'Connect'
    }
  },
  platform: {
    seoTitle: 'Power Tech Knowledge Platform',
    seoDesc: 'Power industry technical documents, standards, software downloads and project requirements — read online and download attachments.',
    seoKeywords: 'power tech documents,electricity standards,smart metering,STS prepaid,AMI,technical docs,utility software',
    homeTitle: 'Power Tech Knowledge Platform',
    homeDesc: 'Share and access power industry technical documents, standards, software and project requirements.',
    searchPlaceholder: 'Search documents, standards, software…',
    ctaFree: 'Browse free docs',
    ctaUpload: 'Upload content',
    ctaRegister: 'Register & earn 50 points',
    ctaUploadSoftware: 'Upload software',
    ctaPublishProject: 'Post a project',
    statTotal: 'Documents',
    statFree: 'Free',
    statDownloads: 'Downloads',
    sectionCategories: 'Categories',
    sectionFeatured: 'Must read',
    sectionTopics: 'Hot topics',
    sectionWeekly: 'Weekly contributors',
    sectionArticles: 'Latest articles',
    sectionHot: 'Popular downloads',
    sectionSoftware: 'Software downloads',
    sectionProjects: 'Project requirements',
    featuredDesc: 'Editor picks across standards, metering and utility practice.',
    topicsDesc: 'Curated collections for faster learning paths.',
    softwareDesc: 'Free downloads or redeem once with points for permanent access.',
    projectsDesc: 'Browse project needs and contact owners after redeeming when required.',
    emptyFeatured: 'No featured articles yet',
    emptySoftware: 'No software yet — sign in to upload packages and earn points',
    emptyProjects: 'No project posts yet',
    topicFallback: 'Topic collection',
    articlesUnit: 'articles',
    viewsUnit: 'views',
    uploadsUnit: 'uploads',
    filesUnit: 'files',
    budgetTbd: 'Budget TBD',
    pointsHint: 'Upload content to earn points; redeem points for premium documents.',
    footerNav: 'Quick links',
    footerCats: 'Categories',
    footerContact: 'Contact',
    serviceHours: 'Service hours',
    report: 'Content reports',
    reportHint: 'Use Report on an article page; we handle cases within 1 business day.',
    layout: {
      admin: 'Admin',
      menu: 'Menu',
      openMenu: 'Open menu',
      closeMenu: 'Close menu',
      logoutSuccess: 'Signed out'
    },
    card: {
      featured: 'Must read',
      free: 'Free',
      pointsN: '{n} points',
      attachmentsN: '{n} attachments'
    },
    files: {
      needRedeem: 'Redeem required',
      preview: 'Preview',
      download: 'Download',
      empty: 'No attachments'
    },
    articles: {
      title: 'Technical library',
      desc: 'Browse power-industry technical documents — read online and download attachments',
      seoTitle: 'Technical library — Power docs & standards',
      seoDesc: 'Browse and search power-industry technical documents, standards and practice notes. Read online and download attachments.',
      seoKeywords: 'power tech library,electricity standards,technical document download,smart metering docs',
      searchPlaceholder: 'Search title, summary or body',
      allCategories: 'All categories',
      typePaid: 'Points docs',
      sortRelevance: 'Relevance',
      sortUpdated: 'Recently updated',
      sortDownloads: 'Most downloads',
      sortViews: 'Most views',
      hot: 'Popular:',
      recent: 'Recent:',
      featuredResult: 'Must read · {n} articles',
      keywordResult: '“{keyword}” — {n} results',
      sortedByRelevance: ' · sorted by relevance',
      emptyFeatured: 'No must-read picks yet — browse all docs or check back later',
      emptyKeyword: 'No docs matching “{keyword}”. Try a category or upload one',
      empty: 'No matching documents',
      goUpload: 'Upload a doc',
      registerUpload: 'Sign up to upload',
      fallbackTitle: 'Popular recommendations',
      suggestDoc: 'Doc',
      suggestCategory: 'Category',
      suggestRecent: 'Recent',
      suggestHot: 'Popular'
    },
    articleDetail: {
      breadcrumbHome: 'Home',
      breadcrumbArticles: 'Docs',
      free: 'Free',
      pointsN: '{n} points',
      viewsN: '{n} views',
      downloadsN: '{n} downloads',
      favorited: 'Saved',
      favorite: 'Save',
      copyShare: 'Copy share text',
      scanFavorite: 'Scan to save',
      report: 'Report',
      teaserTitle: 'Public teaser',
      teaserNote: 'About 200 characters of public preview. Full text and attachments unlock after redeeming.',
      paidTitle: 'Points document',
      paidDesc: 'This article costs {n} points. Redeem to read the full text and download attachments.',
      yourPoints: 'You have {n} points',
      loginToRedeem: 'Please {login} first to redeem with points; or {register} for free points',
      loginLink: 'sign in',
      registerLink: 'register',
      needMorePoints: 'You need {n} more points. {buy}',
      buyPointsNow: 'Buy points now',
      redeemWith: 'Redeem with {n} points',
      pointsInsufficient: 'Not enough points',
      buyPoints: 'Buy points',
      registerFull: 'Register to read full text',
      loginRedeem: 'Sign in to redeem',
      attachments: 'Attachments',
      qaTitle: 'Q&A ({n})',
      askQuestion: 'I have a question about this doc',
      loginToAsk: 'Sign in to ask',
      qaHint: 'Ask the author; authors/admins can reply and pin good answers',
      askPlaceholder: 'Describe your question, e.g. Does this apply to 10kV cable joints?',
      submitQuestion: 'Submit question',
      answered: 'Answered',
      pending: 'Pending',
      pinned: 'Pinned',
      official: 'Author / official',
      unpin: 'Unpin',
      pinAnswer: 'Pin as best answer',
      authorReply: 'Author reply',
      addAnswer: 'Add an answer',
      answerPlaceholder: 'Write your answer…',
      submitAnswer: 'Submit answer',
      qaEmpty: 'No questions yet — ask if anything is unclear',
      commentsTitle: 'Comments ({n})',
      commentPlaceholder: 'Write a comment…',
      postComment: 'Post comment',
      loginToComment: '{login} to comment',
      commentsEmpty: 'No comments yet — be the first',
      infoTitle: 'Document info',
      typePaid: 'Points document',
      typeFree: 'Free document',
      pointsNeeded: 'Points required',
      attachmentCount: 'Attachments',
      attachmentCountN: '{n}',
      redeem: 'Redeem with points',
      unlocked: 'Redeemed',
      earnTitle: 'Earn points',
      earnDesc: 'Upload technical docs — earn points when approved',
      earnCta: 'Upload & earn points',
      relatedHot: 'Popular in category',
      sameAuthor: 'More by author',
      viewProfile: 'View profile',
      wxacodeTitle: 'Scan to save this doc',
      wxacodeAlt: 'Mini Program save code',
      wxacodeHint: 'Scan with WeChat to open the mini program and save this document',
      reportTitle: 'Report inappropriate content',
      reportReason: 'Reason',
      reportSelect: 'Please select',
      reportSecret: 'Possible confidential content',
      reportCopyright: 'Copyright issue',
      reportSpam: 'Spam',
      reportOther: 'Other',
      reportDetail: 'Details',
      notPublished: 'This document is not published yet',
      notFound: 'Article not found',
      unfavorited: 'Removed from saved',
      favoriteSuccess: 'Saved — view it under My Favorites',
      reportLogin: 'Please sign in to report',
      reportReasonRequired: 'Please choose a reason',
      reportSuccess: 'Submitted — we handle cases within 1 business day',
      reportFailed: 'Report failed',
      sharePrefix: '[Power tech doc]',
      shareCopied: 'Share text copied (title + value line)',
      shareCopyFailed: 'Copy failed — please copy the URL from the address bar',
      wxacodeFailed: 'Failed to generate save code (check mini program config)',
      askSuccess: 'Question submitted — the author will reply',
      askFailed: 'Failed to ask',
      answerSuccess: 'Answer published',
      answerFailed: 'Failed to answer',
      pinnedSuccess: 'Pinned',
      unpinnedSuccess: 'Unpinned',
      commentSuccess: 'Comment posted',
      commentFailed: 'Failed to post comment',
      redeemConfirm: 'Redeem 《{title}》 for {n} points?',
      redeemTitle: 'Redeem with points',
      redeemConfirmBtn: 'Confirm redeem',
      alreadyUnlocked: 'You already redeemed this document',
      redeemResult: 'Redeemed! Spent {cost} points, {points} remaining',
      redeemFailed: 'Redeem failed',
      downloadFile: 'Downloading: {name}',
      previewFailed: 'Preview failed'
    },
    software: {
      title: 'Software downloads',
      desc: 'Free software downloads immediately; points software can be downloaded forever after one redeem',
      seoTitle: 'Software downloads — Power & metering tools',
      seoDesc: 'Download power and metering software. Free items download immediately; points software unlocks permanent download after redeem.',
      seoKeywords: 'power software download,metering tools,STS tools,AMI software,utility tools',
      uploadCta: 'Upload software & earn points',
      searchPlaceholder: 'Search software name',
      typePlaceholder: 'Type',
      platformPlaceholder: 'Platform',
      typePaid: 'Points redeem',
      downloadsN: '{n} downloads',
      empty: 'No software yet',
      platformTool: 'Utility',
      platformPlugin: 'Plugin',
      platformOther: 'Other'
    },
    softwareDetail: {
      breadcrumbHome: 'Home',
      breadcrumbSoftware: 'Software',
      version: 'Version {v}',
      downloadsN: '{n} downloads',
      redeemWith: 'Redeem with {n} points',
      unlocked: 'Redeemed — ready to download',
      packages: 'Install packages',
      downloadAfter: 'Redeem to download',
      emptyPackages: 'No install packages',
      pointsLowTitle: 'Not enough points',
      pointsLowConfirm: 'Not enough points. Buy more points?',
      redeemConfirm: 'Redeem 《{name}》 for {n} points?',
      redeemTitle: 'Redeem with points'
    },
    projects: {
      title: 'Project needs',
      desc: 'Post project needs (shown after review). Contact details and files unlock after redeeming when required',
      seoTitle: 'Project needs — Power & metering collaboration',
      seoDesc: 'Browse power and metering project needs. Contact details and files may unlock after redeem when required.',
      seoKeywords: 'power project needs,metering projects,STS projects,AMI collaboration',
      publish: 'Post a project',
      searchPlaceholder: 'Search projects',
      noSummary: 'No summary',
      budget: 'Budget {budget}',
      filesN: '{n} attachments',
      viewsN: '{n} views',
      empty: 'No projects yet'
    },
    projectDetail: {
      breadcrumbHome: 'Home',
      breadcrumbProjects: 'Projects',
      pointsContact: '{n} points for contact',
      freeView: 'Free to view',
      budget: 'Budget {budget}',
      viewsN: '{n} views',
      redeemContact: 'Redeem contact for {n} points',
      unlocked: 'Contact & files unlocked',
      requirement: 'Requirements',
      techStack: 'Technical requirements',
      extra: 'Other notes',
      contact: 'Contact',
      phone: 'Phone: {phone}',
      email: 'Email: {email}',
      contactHintPaid: 'Contact details unlock after redeeming {n} points — sign in and redeem first',
      contactHintLogin: 'Sign in to view contact details',
      attachments: 'Attachments',
      filesLocked: '{n} attachments — visible after redeem',
      pointsLowTitle: 'Not enough points',
      pointsLowConfirm: 'Not enough points. Buy more points?',
      redeemConfirm: 'Redeem contact & files for 《{title}》 with {n} points?',
      redeemTitle: 'Redeem with points'
    },
    projectPublish: {
      breadcrumbHome: 'Home',
      breadcrumbProjects: 'Projects',
      breadcrumbPublish: 'Post project',
      title: 'Post a project need',
      tip: 'No login required. Shown publicly after review. Contact details and attachments are visible to others only after they redeem with points.',
      labelTitle: 'Title',
      labelRequirement: 'Requirements',
      requirementPlaceholder: 'Describe the project needs',
      labelTech: 'Tech requirements',
      techPlaceholder: 'Optional — language, framework, deploy env',
      labelBudget: 'Budget',
      budgetPlaceholder: 'e.g. 50–100k, or negotiable',
      labelExtra: 'Other notes',
      labelPhone: 'Phone',
      phonePlaceholder: 'Mobile or landline',
      labelEmail: 'Email',
      labelFiles: 'Attachments',
      uploadFile: 'Upload file',
      submitAudit: 'Submit for review',
      fillRequired: 'Please fill title, requirements, phone and email',
      submitSuccess: 'Submitted — awaiting admin review'
    },
    topics: {
      title: 'Topics',
      desc: 'Curated collections by scenario — easy to browse and share in group chats',
      seoTitle: 'Topics',
      seoDesc: 'Power tech topic collections: PV grid-connection, substation O&M and more',
      seoKeywords: 'power tech topics,PV grid-connection,substation O&M,smart metering topics',
      fallbackSummary: 'Curated document collection',
      articlesN: '{n} articles',
      viewsN: '{n} views',
      empty: 'No published topics yet'
    },
    topicDetail: {
      breadcrumbHome: 'Home',
      breadcrumbTopics: 'Topics',
      articlesN: '{n} articles',
      viewsN: '{n} views',
      copyShare: 'Copy share text',
      discussion: 'Pinned discussion',
      openDiscussion: 'Open discussion thread',
      discussionFallback: 'Topic discussion',
      emptyComments: 'No discussion yet — sign in to ask first',
      commentPlaceholder: 'Ask a question or share field experience…',
      postComment: 'Post',
      loginToDiscuss: '{login} to join the pinned discussion',
      loginLink: 'Sign in',
      topicArticles: 'Topic documents',
      pinned: 'Pinned',
      emptyArticles: 'No linked documents',
      notFound: 'Topic not found',
      seoSuffix: '{title} — Power tech topic',
      shareCopied: 'Share text copied — ready for group chat',
      posted: 'Posted',
      postFailed: 'Failed to post',
      readLabel: 'Read:',
      summaryLabel: 'Summary:'
    },
    author: {
      fallbackTitle: 'Contributor profile',
      bannerDesc: 'Uploads · download impact · favorites · public badges',
      joinedPrefix: 'Joined',
      noBadges: 'Keep uploading quality docs to unlock Active Contributor / Domain Expert badges',
      uploadAgain: 'Upload another',
      published: 'Published',
      totalDownloads: 'Downloads',
      favorites: 'Favorited',
      totalViews: 'Views',
      weekUploads: 'This week',
      topCategories: 'Top categories:',
      categoryCount: '{name} · {n} articles',
      badgeRules: 'Badge rules (public)',
      theirDocs: 'Their documents',
      totalArticles: '{n} total',
      emptyArticles: 'No published documents yet',
      notFound: 'Contributor not found or disabled'
    },
    team: {
      print: 'Print / Save as PDF',
      toolbarHint: 'One-pager for training leads on how to onboard a crew.',
      brand: 'Power Tech Knowledge Platform',
      title: 'One-pager for training leads',
      lead: 'Onboard a whole crew at once — not link by link.',
      step1: 'Share an invite code.',
      step1Body: 'Both sides earn points; new colleagues can redeem sample docs the same day.',
      step2: 'Create a crew pack.',
      step2Body: 'Put common standards in a read-only pack and share one link in the group.',
      step3: 'Follow Q&A.',
      step3Body: 'Ask beside a document; authors or admins reply and pin answers.',
      foot: 'Start with one crew pilot: invite 5 people + 1 pack (safety / grid / O&M, 2 docs each).',
      packMeta: '{owner} shared a crew pack · read-only · {n} articles',
      packFree: 'Free',
      packPoints: '{n} points',
      packEmpty: 'This pack is empty',
      packNotFound: 'Pack not found'
    }
  },
  auth: {
    login: {
      title: 'Sign in',
      desc: 'Sign in to upload docs, earn points and redeem technical documents',
      username: 'Username',
      password: 'Password',
      submit: 'Sign in',
      noAccount: 'No account?',
      registerNow: 'Sign up',
      backHome: 'Back to home',
      usernameRequired: 'Please enter username',
      passwordRequired: 'Please enter password',
      success: 'Signed in',
      failed: 'Sign-in failed'
    },
    register: {
      title: 'Sign up',
      desc: 'Get 50 points on signup; earn more when uploaded docs are approved',
      username: 'Username (4–20 chars)',
      name: 'Display name',
      email: 'Email',
      password: 'Password (6+ chars)',
      inviteCode: 'Invite code (optional — both earn points)',
      confirmPassword: 'Confirm password',
      submit: 'Sign up',
      hasAccount: 'Already have an account?',
      loginNow: 'Sign in',
      backHome: 'Back to home',
      usernameRequired: 'Please enter username',
      usernameLength: 'Username must be 4–20 characters',
      nameRequired: 'Please enter display name',
      emailRequired: 'Please enter email',
      emailInvalid: 'Invalid email format',
      passwordRequired: 'Please enter password',
      passwordMin: 'Password must be at least 6 characters',
      confirmRequired: 'Please confirm password',
      passwordMismatch: 'Passwords do not match',
      success: 'Registered! You received {n} bonus points',
      failed: 'Registration failed'
    }
  },
  user: {
    layout: {
      backHome: "Back to home",
      title: "Account",
      pointsN: "{n} points",
      logoutAria: "Sign out",
      overview: "Overview",
      upload: "Upload",
      myUploads: "My uploads",
      uploadSoftware: "Upload software",
      mySoftware: "My software",
      myProjects: "My projects",
      messages: "Messages",
      favorites: "Favorites",
      invite: "Invite",
      teamPacks: "Crew packs",
      questions: "Q&A",
      buyPoints: "Buy points",
      pointsHistory: "Points history",
      changePassword: "Change password",
      logout: "Sign out",
      passwordSuccess: "Password updated — please sign in again",
      logoutSuccess: "Signed out"
    },
    titles: {
      center: "Account",
      upload: "Upload document",
      uploadSoftware: "Upload software",
      mySoftware: "My software",
      myProjects: "My projects",
      messages: "Messages",
      favorites: "Favorites",
      invite: "Crew invite",
      teamPacks: "Crew packs",
      questions: "My Q&A",
      points: "Points history",
      buyPoints: "Buy points"
    },
    status: {
      pending: "Pending review",
      published: "Published",
      rejected: "Rejected",
      draft: "Draft",
      listed: "Listed"
    },
    center: {
      welcomeTitle: "Welcome to the Power Tech Knowledge Platform",
      welcomeBody: "You received {n} bonus points. Complete the starter tasks below to find docs and start sharing.",
      recommendFree: "Recommended free docs:",
      hello: "Hello, {name}",
      helloHint: "Upload quality technical docs — earn points when approved",
      currentPoints: "Current points",
      buyPoints: "Buy points",
      onboardingTitle: "Starter tasks",
      taskBrowse: "Browse 1 free document",
      taskComment: "Post 1 comment",
      taskFavorite: "Save 1 document",
      taskUpload: "Learn how to upload",
      actionBuyTitle: "Buy points",
      actionBuyDesc: "WeChat / Alipay top-up",
      actionUploadTitle: "Upload docs",
      actionUploadDesc: "Share your technical documents",
      actionFavTitle: "My favorites",
      actionFavDesc: "Revisit saved documents",
      actionRedeemTitle: "Redeem docs",
      actionRedeemDesc: "Use points to unlock documents",
      contribTitle: "My contribution impact",
      viewPublicProfile: "View public profile",
      noBadges: "No badges yet — keep sharing to unlock",
      published: "Published",
      downloads: "Downloads",
      favorited: "Favorited",
      thisWeek: "This week",
      contribRules: "Active Contributor: ≥3 published and ≥30 downloads; Domain Expert: ≥5 published, and ≥3 in one category or ≥200 downloads",
      loadingContrib: "Loading contribution data…",
      pointsRulesTitle: "Points rules",
      ruleRegister: "New users receive {n} points on signup",
      ruleApproval: "Approved uploads earn {base} points, plus {per} per attachment",
      rulePurchase: "You can also buy point packs via {pay} — credited instantly",
      ruleRedeem: "Points docs can be redeemed for full text and attachment downloads",
      wechatAlipay: "WeChat / Alipay",
      recentPoints: "Recent point activity",
      viewAll: "View all"
    },
    messages: {
      title: "Messages",
      markAllRead: "Mark all as read",
      empty: "No messages yet. You will be notified here when a document is approved or rejected.",
      reward: "Earned {n} points",
      typeApproved: "Approved",
      typeRejected: "Rejected",
      typeNotify: "Notice",
      markedAll: "All marked as read"
    },
    invite: {
      title: "Crew invite",
      desc: "Share the link with colleagues. After they register with your code, you both earn {n} points.",
      copyLink: "Copy invite link",
      teamIntro: "One-pager for training leads",
      invitedCount: "Invited {n} people",
      copied: "Copied",
      copyFailed: "Copy failed"
    },
    favorites: {
      title: "My favorites",
      desc: "Saved documents for quick revisit and sharing",
      empty: "No favorites yet — pick a few from the library",
      browse: "Browse docs",
      loadFailed: "Failed to load favorites"
    },
    myProjects: {
      colTitle: "Title",
      colStatus: "Status",
      colBudget: "Budget",
      colPoints: "Points",
      colSubmitted: "Submitted",
      empty: "Projects you post while signed in appear here. Anonymous posts cannot be listed here."
    },
    mySoftware: {
      title: "My software",
      upload: "Upload software",
      colName: "Name",
      colType: "Type",
      colStatus: "Status",
      colDownloads: "Downloads",
      colReject: "Review note"
    },
    myArticles: {
      title: "My uploads",
      uploadNew: "Upload new",
      approvedTitle: "《{title}》 was approved",
      docFallback: "Document",
      rewardSuffix: ", earned {n} points",
      uploadAgain: "Upload another",
      viewPublished: "View published",
      reviewHint: "Pending docs are typically reviewed within 24–48 hours. Results arrive as in-app messages.",
      colTitle: "Title",
      colCategory: "Category",
      colStatus: "Status",
      colAttachments: "Files",
      colViews: "Views",
      colSubmitted: "Submitted",
      colActions: "Actions",
      rejectDefault: "Does not meet publish requirements",
      rewardGot: "Earned {n} points",
      view: "View",
      reupload: "Re-upload",
      empty: "No uploads yet",
      uploadNow: "Upload now",
      etaOverdue: "Waiting {hours}h — past 48h SLA; we will prioritize it",
      etaWarn: "Waiting {hours}h — finishing soon (target within 48h)",
      etaNormal: "ETA {warn}–{target}h · waited {hours}h (~{remain}h left)"
    },
    myQuestions: {
      title: "My Q&A",
      desc: "Track questions you asked and questions waiting for your reply",
      tabAsked: "Asked by me",
      tabPending: "Awaiting my reply",
      articleFallback: "Doc #{id}",
      answered: "Answered",
      pending: "Pending",
      answersN: "{n} answers",
      lastReplyPrefix: "Last reply",
      pinned: "Pinned",
      goArticle: "Open doc / reply",
      emptyPending: "No questions awaiting your reply",
      emptyAsked: "No questions yet — open a doc and tap “I have a question”",
      browse: "Browse docs"
    },
    buyPoints: {
      title: "Buy points",
      current: "Current points: {n}. Points are credited right after payment.",
      recommended: "Popular",
      pointsUnit: "points",
      bonusTip: "Includes {n} bonus points",
      payMethod: "Payment method",
      methodWechat: "WeChat Pay",
      methodAlipay: "Alipay",
      package: "Package",
      packageSummary: "{label} ({n} points)",
      amountDue: "Amount due",
      payNow: "Pay now",
      payTip: "You will be redirected to the official WeChat / Alipay checkout",
      successTitle: "Payment successful",
      successDesc: "Points credited. Continue browsing and redeeming documents.",
      purchased: "This purchase",
      purchasedPoints: "+{n} points",
      totalPoints: "Current total",
      totalPointsN: "{n} points",
      gotIt: "Got it",
      wechatTitle: "WeChat QR payment",
      payAmount: "Amount: ¥{amount}",
      qrAlt: "WeChat Pay QR code",
      wechatHint: "Scan with WeChat to complete payment",
      waitingPay: "Waiting for payment…",
      confirmPay: "Pay ¥{price} with {method} for {n} points?",
      confirmTitle: "Confirm payment",
      goPay: "Pay",
      createOrderFailed: "Failed to create payment order",
      orderFailed: "Failed to create order",
      allowPopup: "Please allow pop-ups to complete Alipay payment"
    },
    pointsHistory: {
      current: "Current points",
      buy: "Buy points",
      title: "Points history",
      colTime: "Time",
      colDesc: "Description",
      colChange: "Change",
      colType: "Type",
      empty: "No point records yet",
      typeEarn: "Reward",
      typePurchase: "Purchase",
      typeSpend: "Spend",
      typeAdmin: "Admin adjustment"
    },
    teamPacks: {
      title: "Crew packs",
      desc: "Turn favorites into a read-only pack and share with your crew. They can view, not edit your favorites.",
      create: "New pack",
      articlesN: "{n} articles",
      manage: "Manage",
      copyLink: "Copy read-only link",
      delete: "Delete",
      empty: "No crew packs yet",
      createTitle: "New pack",
      namePlaceholder: "e.g. Substation Crew A training pack",
      cancel: "Cancel",
      createBtn: "Create",
      packFallback: "Pack",
      shareLink: "Read-only link: {url}",
      importFav: "Import from my favorites",
      articleId: "Document ID",
      add: "Add",
      remove: "Remove",
      linkCopied: "Read-only link copied",
      deleteConfirm: "Delete “{name}”?",
      tip: "Notice",
      imported: "Favorites imported",
      createFailed: "Create failed"
    },
    uploadSoftware: {
      title: "Upload software",
      tip: "After approval you earn 100 base points + 20 per install package. Suggested type is confirmed by admins.",
      name: "Name",
      summary: "Summary",
      description: "Details",
      version: "Version",
      versionPlaceholder: "e.g. 1.0.0",
      platform: "Platform",
      suggestType: "Suggested type",
      typeFree: "Free",
      typePaid: "Points redeem",
      suggestPoints: "Suggested points",
      packages: "Install packages",
      dragHint: "Drop packages here, or click to upload (max 2GB each)",
      uploading: "Uploading — large files may take a while…",
      remove: "Remove",
      submit: "Submit for review",
      platformTool: "Utility",
      platformPlugin: "Plugin",
      platformOther: "Other",
      uploadDone: "Upload complete",
      uploadFailed: "Upload failed",
      fillRequired: "Please fill name and summary",
      needPackage: "Please upload an install package",
      submitSuccess: "Submitted — awaiting review",
      submitFailed: "Submit failed"
    },
    upload: {
      title: "Upload a technical document",
      desc: "About {minutes} minutes to submit. Review within {sla} hours; expected reward ~{reward} points (base {base} + {per} per attachment). Confirm the content is non-confidential and you have the right to share.",
      minutes: "10",
      sla: "24–48",
      draftSaving: "Saving…",
      draftSavedPrefix: "Draft auto-saved",
      draftHint: "Edits are auto-saved as a local draft",
      draftBannerTitle: "Unsubmitted draft found",
      draftBannerBody: "Continue editing the previous content, or clear and start over.",
      restoreDraft: "Restore draft",
      discardDraft: "Discard draft",
      checkTitle: "Title",
      checkCategory: "Category",
      checkSummary: "Summary",
      checkContent: "Body",
      checkFile: "Attachment (optional)",
      templatesLabel: "Apply a template:",
      tplSafety: "Power safety",
      tplRenewable: "Renewable grid-connection",
      tplDistribution: "Distribution engineering",
      tplTransmission: "Transmission",
      tplSubstation: "Substation O&M",
      labelTitle: "Title",
      titlePlaceholder: "e.g. PV plant grid-connection acceptance checklist & common rejections",
      labelCategory: "Category",
      categoryPlaceholder: "Choose a category (prefer underserved ones)",
      labelAuthor: "Author byline",
      authorPlaceholder: "Name shown on the document",
      labelSummary: "Summary",
      summaryPlaceholder: "2–3 sentences on use case and value (helps search)",
      labelContent: "Content",
      contentPlaceholder: "Apply a template first, then replace with your field notes, standards and cases",
      labelFiles: "Attachments",
      dragHint: "Drop files here, or {em}",
      clickUpload: "click to upload",
      uploadTip: "Supports {ext}; max {size} per file. Prefer original PDF/Word specs or checklists.",
      maxSize: "50MB",
      uploading: "Uploading attachment…",
      remove: "Remove",
      submitHint: "Typical review {sla} hours; expected ~{reward} points if approved.",
      declaration: "I confirm this is non-confidential and I have the right to share",
      submit: "Submit for review",
      saveDraft: "Save draft",
      reset: "Reset",
      ruleTitle: "Please enter a title",
      ruleSummary: "Please enter a summary",
      ruleContent: "Please enter content",
      ruleCategory: "Please choose a category",
      ruleAuthor: "Please enter author byline",
      draftSavedLocal: "Draft saved on this device",
      draftRestored: "Draft restored",
      draftDiscarded: "Draft discarded",
      templateApplied: "Applied “{label}” template — edit as needed before submit",
      templateConfirm: "Applying a template will overwrite the current title/summary/body. Continue?",
      templateTitle: "Apply template",
      templateOverwrite: "Overwrite & apply",
      badFileType: "Unsupported file type. Please upload: {ext}",
      fileTooLarge: "File size must not exceed 50MB",
      uploadedFile: "Uploaded: {name}",
      uploadFailed: "Upload failed",
      resetConfirm: "Clear the form? The local draft will also be deleted.",
      resetTitle: "Reset",
      needDeclaration: "Please check “non-confidential, right to share”",
      submitSuccessTitle: "Submitted",
      submitSuccessHtml: "<p>Your document is in the review queue.</p><ul style=\"padding-left:18px;line-height:1.8;margin:12px 0\"><li>Typical review time: <strong>24–48 hours</strong></li><li>Expected points if approved: <strong>{reward}</strong> (base {base} + {files}×{per} attachments)</li><li>Track progress under “My uploads”</li></ul>",
      viewMyUploads: "View my uploads",
      submitFailed: "Submit failed"
    }
  }
}
